export default "__VITE_ASSET__cmcNCaX$__"